import { fetchCSV } from "../utils/dataCache";

const BASE = "https://steam-scrape-production.s3.us-east-1.amazonaws.com/";

export function hydrateSteamMetadata(document) {
  const { schemaVersion, columns, rowCount } = document || {};
  if (schemaVersion !== 1 || !Number.isInteger(rowCount) || rowCount <= 0 ||
      !columns?.app_id || !columns?.name || !columns?.type ||
      Object.values(columns).some(values => !Array.isArray(values) || values.length !== rowCount)) {
    throw new Error("Invalid Steam metadata snapshot");
  }
  const fields = Object.keys(columns);
  return Array.from({ length: rowCount }, (_, index) =>
    Object.fromEntries(fields.map(field => [field, columns[field][index]])));
}

export async function loadSteamSnapshot() {
  const manifest = JSON.parse(await fetchCSV(`${BASE}steam_dashboard/manifest.json`, { ttl: 0 }));
  if (manifest.schemaVersion !== 1 ||
      ![manifest.cards?.key, manifest.catalog?.key].every(key =>
        typeof key === "string" && /^steam_dashboard\/[a-f0-9-]+\/(cards|catalog)\.json\.gz$/.test(key))) {
    throw new Error("Invalid Steam snapshot manifest");
  }
  const read = async entry => {
    const data = hydrateSteamMetadata(JSON.parse(await fetchCSV(`${BASE}${entry.key}`, { ttl: 10 * 60 * 1000 })));
    if (data.length !== entry.rowCount) throw new Error("Steam snapshot row count mismatch");
    return data;
  };
  return { loadCards: () => read(manifest.cards), loadCatalog: () => read(manifest.catalog) };
}
